<template>
  <div v-if="donation">
    <h3 class="mb-5">Choose your amount</h3>
    <div class="d-flex align-items-edges">
      <div class="custom-control col-auto custom-switch align-self-center pr-1">
        <input
          type="checkbox"
          class="custom-control-input"
          id="monthly"
          v-model="donation.monthly"
          true-value="1"
          false-value="0"
        />
        <label class="custom-control-label" for="monthly"
          ><template v-if="donation.monthly == 0">
            Make it a monthly donation
          </template>
          <template v-else>
            Repeat this for
            <input
              id="months"
              type="number"
              min="2"
              class="form-control form-control-xs"
              aria-describedby="helpId"
              placeholder=""
              v-model="donation.months"
            />
            months
          </template></label
        >
      </div>
      <select
        class="form-control form-control-xs pl-0"
        id="currency"
        v-model="donation.currency"
        @change="currency_code = donation.currency.currency"
      >
        <option
          v-bind:value="currency"
          v-for="currency in currencies"
          v-bind:key="currency.id"
        >
          {{ currency.symbol }} {{ currency.currency }}
        </option>
      </select>
    </div>
    <small
      class="text-danger"
      v-if="$store.state.country == 'us' && currency_code != 'USD'"
      ><small>
        Please note that your receipt will be issued in the USD equivalent
      </small></small
    >
    <small
      class="text-danger"
      v-else-if="$store.state.country == 'can' && currency_code != 'CAD'"
      ><small>
        Please note that your receipt will be issued in the CAD equivalent
      </small></small
    >
    <div
      v-if="
        organization.amount_type_id == 1 || organization.amount_type_id == 2
      "
      class="form-group mb-5 amount-selector"
    >
      <div class="btn-row first-row mt-5">
        <a
          href="#!"
          @click.prevent="setAmount(amnts[0])"
          :class="[donation.amount == amnts[0] ? 'active' : '']"
          class="btn btn-success col-4 px-0"
          ><small>{{ donation.currency.symbol }}</small>
          {{ amnts[0] }}
          <span v-if="donation.monthly == 1">/m</span></a
        >
        <a
          href="#!"
          @click.prevent="setAmount(amnts[1])"
          :class="[donation.amount == amnts[1] ? 'active' : '']"
          class="btn btn-success col-4 px-0 border-right border-left"
          ><small>{{ donation.currency.symbol }}</small
          >{{ amnts[1] }}<span v-if="donation.monthly == 1">/m</span></a
        >
        <a
          href="#!"
          @click.prevent="setAmount(amnts[2])"
          :class="[donation.amount == amnts[2] ? 'active' : '']"
          class="btn btn-success col-4 px-0"
          ><small>{{ donation.currency.symbol }}</small
          >{{ amnts[2] }}<span v-if="donation.monthly == 1">/m</span></a
        >
      </div>
      <div class="btn-row">
        <a
          href="#!"
          @click.prevent="setAmount(amnts[3])"
          :class="[donation.amount == amnts[3] ? 'active' : '']"
          class="btn btn-success col-4 px-0"
          ><small>{{ donation.currency.symbol }}</small
          >{{ amnts[3] }}<span v-if="donation.monthly == 1">/m</span></a
        >
        <a
          href="#!"
          @click.prevent="setAmount(amnts[4])"
          :class="[donation.amount == amnts[4] ? 'active' : '']"
          class="btn btn-success col-4 px-0 border-right border-left"
          ><small>{{ donation.currency.symbol }}</small
          >{{ amnts[4] }}<span v-if="donation.monthly == 1">/m</span></a
        >
        <a
          href="#!"
          @click.prevent="setAmount(amnts[5])"
          :class="[donation.amount == amnts[5] ? 'active' : '']"
          class="btn btn-success col-4 px-0"
          ><small>{{ donation.currency.symbol }}</small
          >{{ amnts[5] }}<span v-if="donation.monthly == 1">/m</span></a
        >
      </div>
      <div class="btn-row last-row">
        <a
          href="#!"
          @click.prevent="setAmount(amnts[6])"
          :class="[donation.amount == amnts[6] ? 'active' : '']"
          class="btn btn-success col-4 px-0"
          ><small>{{ donation.currency.symbol }}</small
          >{{ amnts[6] }}<span v-if="donation.monthly == 1">/m</span></a
        >
        <input
          name="amount"
          id="amount"
          class="btn btn-success col-8 border-left"
          placeholder="Other amount"
          v-model="donation.nameAmount"
          :class="[donation.nameAmount > 0 ? 'active' : '']"
          @click="donation.amount = 0"
          v-on:keydown.enter.prevent="donation.amount = 0"
        />
      </div>
    </div>
    <div v-else>
      <input
        name="amount"
        id="amount"
        class="col-12 form-control my-4 border-success"
        placeholder="Enter your amount"
        v-model="donation.nameAmount"
        @click="donation.amount = 0"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    donation: {},
    organization: {},
  },
  data() {
    return {
      currencies: [],
      currency_code: "",
    };
  },
  watch: {
    "$store.state.country": function () {
      this.change_currency();
    },
  },
  mounted() {
    let self = this;
    this.axios
      .get(window.API_URL + "currencies")
      .then(function (response) {
        self.currencies = response.data;
        if (self.$store.state.country === "us") {
          self.donation.currency = self.currencies[0];
        } else {
          self.donation.currency = self.currencies[1];
        }
        self.currency_code = self.donation.currency.currency;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    setAmount(amount) {
      this.donation.amount = amount;
      this.donation.nameAmount = "";
    },
    change_currency() {
      if (this.$store.state.country === "us")
        this.donation.currency = this.currencies[0];
      else this.donation.currency = this.currencies[1];
      this.currency_code = this.donation.currency.currency;
    },
  },
  computed: {
    amnts() {
      if (this.organization.amount_type_id == 2) {
        return JSON.parse(this.organization.amounts);
      } else {
        return [50, 100, 180, 250, 500, 1000, 1800];
      }
    },
  },
};
</script>
<style lang="scss">
.amount-selector {
  .btn.border-right {
    border-right: 0.5px solid #2a8a6c !important;
  }
  .btn.border-left {
    border-left: 0.5px solid #2a8a6c !important;
  }
  .btn.active {
    background: #389e7f;
    box-shadow: inset 0 0 10px rgba($color: #000000, $alpha: 0.3) !important;
  }
  .btn:not([class*="btn-outline"]) {
    border-radius: 0;
  }
  .btn-row.first-row {
    clear: both;
    .btn {
      border-bottom: 0.5px solid #2a8a6c !important;
    }
    .btn:first-child {
      border-top-left-radius: 5px;
    }
    .btn:last-child {
      border-top-right-radius: 5px;
    }
  }
  .btn-row.last-row {
    .btn {
      border-top: 0.5px solid #2a8a6c !important;
    }
    .btn:first-child {
      border-bottom-left-radius: 5px;
    }
    .btn:last-child {
      border-bottom-right-radius: 5px;
    }
  }
}
#months {
  display: inline-block;
  text-align: center;
  margin: 0 3px;
  width: 3em;
  box-sizing: content-box;
  padding: 0 2px;
  height: 24px;
  border-color: #ddd;
}
#amount {
  -webkit-user-select: text;
  user-select: text;
  font-size: 25px;
}
</style>